import { useQuery, useQueryClient } from "react-query";
import { USER_DATA_INFO_QUERY_KEY } from "../../shared/enums/useQueryKeys";
import { getDepositFormParams } from "./gateway";

export const useGetDepositFormParams = (
  mode: "certificate" | "subscription" | "application" | "violationCase",
  appId?: string | null,
  subscriptionStart?: string,
  finePaymentId?: number,
) => {
  const formData = new FormData();
  formData.append("mode", mode);
  if (appId) {
    formData.append("appId", appId);
  }
  if (subscriptionStart) {
    formData.append("subscriptionStart", subscriptionStart);
  }
  if (finePaymentId) {
    formData.append("finePaymentId", finePaymentId.toString());
  }
  const queryClient = useQueryClient();
  return useQuery({
    queryFn: () => getDepositFormParams(formData),
    queryKey: ["getDepositFormParams", appId, subscriptionStart, finePaymentId],
    onSuccess: () => {
      queryClient.invalidateQueries(USER_DATA_INFO_QUERY_KEY);
    },
  });
};
